import _slicedToArray from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { useLayoutEffect } from "./useLayoutEffect.js";
export var useRTL = function useRTL() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isRTL = _React$useState2[0],
      setIsRTL = _React$useState2[1];

  useLayoutEffect(function () {
    setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
  }, []);
  return isRTL;
};